
import {
  Component,
  Vue
} from 'vue-property-decorator'
import SettingService from '../../../../services/setting-service'
import {
  JobModule
} from '../../../../store/JobModule'
import {
  AuthModule
} from '@/store/modules/AuthModule'
import QuantityWidget from '../../../../widget/Quantity.vue'
import {
  ToastModule
} from '@/store/modules/ToastModule'
  @Component({
    name: 'JobComplete',
    components: {
      QuantityWidget
    }
  })
export default class JobComplete extends Vue {
    protected isRemark = false
    protected isExist = false
    protected completedDate: any = null

    get job () {
      return JobModule.job
    }

    mounted () {
      this.boot()
    }

    protected boot () {
      this.isRemark = true;
      (this.$refs.QuantityWidget as any).show(this.job)
    }

    protected saveJobComplete () {
      const data: any = {
        job_id: this.job.id,
        completed_date: this.job.completed_date,
        oil_quantity: this.job.oil_quantity ? this.job.oil_quantity : 0,
        water_quantity: this.job.water_quantity ? this.job.water_quantity : 0,
        modified_user: AuthModule.user.fullname
      }

      SettingService.complete(data).then(response => {
        ToastModule.message(response.data.message)
        JobModule.setJobDetails(this.job.id)
      }).catch(error => {
        console.log(error)
      })
    }
}

